// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___1AGYd","group":"style__group___2uWe7","groupTitle":"style__groupTitle___3ZWls","name":"style__name___3DW-e","col-container":"style__col-container___1RL2P","col-title":"style__col-title___He8wj","col-input":"style__col-input___3hjSq","btnLine":"style__btnLine___2YP4v","btn":"style__btn___3UEk9","btnLink":"style__btnLink___QYaZ4","btnCancel":"style__btnCancel___1RoUv","btnDelete":"style__btnDelete___3zK2s","modal":"style__modal___3neEI","require-tag":"style__require-tag___2NXAP"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/style.scss
// module id = 1730
// module chunks = 0